import React from 'react';
import { Box } from '@radix-ui/themes';

type AudiencePaginationProps = {
  rangeTruncated: boolean;
  isLoading?: boolean;
  loadMoreSentinelRef: (node: HTMLDivElement | null) => void;
};

export const AudiencePagination: React.FC<AudiencePaginationProps> = ({ rangeTruncated, isLoading, loadMoreSentinelRef }) => {
  if (!rangeTruncated) return null;

  return (
    <Box
      ref={loadMoreSentinelRef}
      aria-hidden="true"
      className="list-sentinel"
    />
  );
};
